export const EdenMark = ({ height = 34, arch = "#F5F1E6" }) => (
  <svg width={Math.round(height * 0.65)} height={height} viewBox="0 0 62 96" fill="none" aria-hidden="true">
    <path d="M6 92 V27 C6 11 17 4 31 4 C45 4 56 11 56 27 V92" stroke={arch} strokeWidth="5" />
    <path d="M31 34 C38.5 41 42.5 49 42.5 58 C42.5 67 38.5 75 31 82 C23.5 75 19.5 67 19.5 58 C19.5 49 23.5 41 31 34 Z" fill="#A3AE88" />
    <line x1="31" y1="43" x2="31" y2="80" stroke="#1F3B2D" strokeWidth="2.6" />
  </svg>
);

const Logo = ({ variant = "dark" }) => {
  const dark = variant === "dark";
  return (
    <span className="logo-lockup">
      <EdenMark arch={dark ? "#1F3B2D" : "#F5F1E6"} />
      <span className={`logo-divider ${dark ? "on-light" : "on-dark"}`} />
      <span className="logo-words" style={{ color: dark ? "#1F3B2D" : "#F5F1E6" }}>
        <strong>EDEN</strong>
        <small>HOSPITALITY</small>
      </span>
    </span>
  );
};

export default Logo;
